import { gsap } from "gsap";
    
import { ScrollTrigger } from "gsap/ScrollTrigger";

import debounce from './debounce';


gsap.registerPlugin(ScrollTrigger);

/**
 * トップページ　aboutパララックス
*/
const parallax = () => {
    const container = document.querySelector('.js_parallax');
    if (!container) return;

    const targets = container.querySelectorAll('[data-parallax]');
    if (!targets.length) return;

    targets.forEach((target) => {
        const axis = target.getAttribute('data-parallax') || 'y';
        const speedAttr = target.getAttribute('data-parallax-speed');
        const speed = speedAttr ? Number(speedAttr) : 20; // 単位: percent
        const start = target.getAttribute('data-parallax-start') || 'top bottom';
        const end = target.getAttribute('data-parallax-end') || 'bottom top';
        const scrubAttr = target.getAttribute('data-parallax-scrub');
        const scrub = scrubAttr !== null ? Number(scrubAttr) : true; // 数値指定で慣性（遅延）

        const tweenVars = axis === 'x'
            ? { xPercent: speed }
            : { yPercent: speed };

        gsap.to(target, {
            ...tweenVars,
            ease: 'none',
            scrollTrigger: {
                trigger: target,
                start,
                end,
                scrub,
                invalidateOnRefresh: true,
            },
        });
    });

	// bodyの高さが変わったらリフレッシュ（アコーディオンによる計算位置のずれ対策）
	const throttledBgChangeAndRefresh = debounce(() => {
        ScrollTrigger.refresh();
	}, 100);
	const resizeObserver = new ResizeObserver(entries => {
		throttledBgChangeAndRefresh();
	});
	resizeObserver.observe(document.body);
}

export default parallax;